export default {
  data() {
    return {
      fallbackImageUrl: require('@/static/img/product-alternate-image.png')
    };
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.fallbackImageUrl;
    }
  }
};
